export default __webpack_public_path__ + "static/media/away.e9e69644.svg";